module.exports = __webpack_public_path__ + "conheca/static/media/background.ce9bfc87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Desafios/background.jpg
// module id = 350
// module chunks = 37